import React from "react";
import { cn } from "../../../../lib/utils";

interface INumberCellProps {
  value?: number | null;
  isEditable?: boolean;
  onChange?: (value: number | null) => void;
  className?: string;
  inputClassName?: string;
  enableDefaultStyles?: boolean;
}

const NumberCell: React.FC<INumberCellProps> = ({
  value,
  isEditable,
  onChange,
  className,
  inputClassName,
  enableDefaultStyles = true,
}) => {
  if (!isEditable) {
    return (
      <div className={cn("px-2 py-1 text-sm", className)}>{value ?? "-"}</div>
    );
  }

  return (
    <input
      type="number"
      value={value ?? ""}
      onChange={(e) => {
        if (onChange) {
          const raw = e.target.value;
          if (raw === "") {
            onChange(null);
            return;
          }
          const numValue = parseFloat(raw);
          onChange(Number.isFinite(numValue) ? numValue : null);
        }
      }}
      className={cn(
        enableDefaultStyles && "w-full p-1 text-sm border-none outline-none bg-transparent focus:bg-[#F3F4F6] rounded focus:border-[#4B5563]",
                inputClassName
      )}
    />
  );
};

export default NumberCell;
